<template>
  <div id="main-wrapper">
    <div
      class="content-container profile-page deposit-live transactions-dep bonus-page refer-page"
    >
      <div class="page-wrap">
        <div class="page-content clearfix">
          <div class="main-content f-left">
            <div class="dep-nav">
              <ul>
                <li><router-link to="/bonus">{{$t('refer_earn.bonus')}}</router-link></li>
                <li class="active">
                  <router-link to="/refer-earn">{{$t('refer_earn.refer_earn')}}</router-link>
                </li>
              </ul>
            </div>
            <div class="content-holder">
              <div class="refer-holder">
                <p>
                  {{$t('refer_earn.refer_friend')}} <br />
                  <span style="color: #71c8f0">{{$t('refer_earn.earn_dollar_twenty_five')}}</span> {{$t('refer_earn.per_friend')}}
                </p>
              </div>
              <div class="form-holder">
                <ul>
                  <li>
                    <div class="share-input">
                      <input type="text" name="" value="3Mygykq6CvDgqFyL3LsN4C7WvHCCkcZaWY" />
                      <a href="#clipboard" class="popup-link-holder">
                        <img src="assets/images/clip-ico.png" alt="" />
                      </a>
                    </div>
                    <input type="submit" name="" value="Share" class="btn btn-blue btn-share" />
                  </li>
                </ul>
              </div>
              <div class="clearfix">
                <div class="half-width f-left note">
                  <p>
                    <strong>{{$t('refer_earn.why_refer_someone_to_us')}} </strong>
                    <br /><br />
                    {{$t('refer_earn.refer_someone_point_one')}} <br />
                    {{$t('refer_earn.refer_someone_point_two')}} <br />
                    {{$t('refer_earn.refer_someone_point_three')}}
                    <br />
                    {{$t('refer_earn.refer_someone_point_four')}} <br />
                  </p>
                </div>
                <div class="half-width f-right note">
                  <p>
                    <strong>{{$t('refer_earn.what_need_to_do')}}</strong> <br /><br />
                    {{$t('refer_earn.what_need_to_do_point_one')}} <br />
                    {{$t('refer_earn.what_need_to_do_point_two')}}
                    <br />
                    {{$t('refer_earn.what_need_to_do_point_three')}} <br />
                  </p>
                </div>
              </div>
              <div class="btn-holder t-left">
                <router-link to="/referral-list" class="btn btn-yellow">{{$t('refer_earn.referral_list')}}</router-link>
              </div>
            </div>
            <div class="img-holder">
              <img src="assets/images/refer-img2.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
